import { render, staticRenderFns } from "./ProfileRelationshipsCard.vue?vue&type=template&id=e39b4df6"
import script from "./ProfileRelationshipsCard.vue?vue&type=script&lang=js"
export * from "./ProfileRelationshipsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports